import { render, staticRenderFns } from "./DownLoadscopy.vue?vue&type=template&id=6dc433a2&scoped=true"
import script from "./DownLoadscopy.vue?vue&type=script&lang=js"
export * from "./DownLoadscopy.vue?vue&type=script&lang=js"
import style0 from "./DownLoadscopy.vue?vue&type=style&index=0&id=6dc433a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc433a2",
  null
  
)

export default component.exports